import { SVGProps } from "react";

interface Props extends SVGProps<SVGSVGElement> {
  width?: number,
  height?: number,
  color?: StrokeColors
}

const LowBandwidth = ({ color = 'stroke-white'}: Props) => {
  return (
    <svg width="30" className={color} height="30" viewBox="0 0 26 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M0.999999 12.7107C0.999999 19.1783 5.17258 18.566 11.8 18.566C18.4274 18.566 25 19.1783 25 12.7107M0.999999 12.7107C0.999999 6.24305 6.37258 1 13 1M0.999999 12.7107H4M25 12.7107C25 6.24305 19.6274 1 13 1M25 12.7107H22M13 1V3.92767M4.50589 4.5132L11.2001 10.9541M4.50589 21L4.75056 20.7612C5.58073 19.9511 5.99582 19.546 6.48023 19.2563C6.9097 18.9995 7.37792 18.8102 7.86769 18.6955C8.42012 18.566 9.00714 18.566 10.1812 18.566L15.8189 18.5661C16.9929 18.5661 17.5799 18.5661 18.1323 18.6955C18.6221 18.8103 19.0903 18.9995 19.5198 19.2564C20.0042 19.546 20.4192 19.9511 21.2494 20.7613L21.494 21M21.494 4.5132L19.4103 6.54671M10.6 12.7107C10.6 14.0042 11.6745 15.0528 13 15.0528C14.3255 15.0528 15.4 14.0042 15.4 12.7107C15.4 11.4172 14.3255 10.3685 13 10.3685C11.6745 10.3685 10.6 11.4172 10.6 12.7107Z" stroke={color} stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
</svg>

  )
}

export default LowBandwidth